import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-down\"><defs><style type=\"text/css\">@font-face { font-family: element-icons; src: url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.woff\") format(\"woff\"), url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.ttf \") format(\"truetype\"); }\n</style></defs><path d=\"M500.8 604.779L267.307 371.392l-45.227 45.27 278.741 278.613L779.307 416.66l-45.248-45.248z\" p-id=\"5315\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/m-common/svg/md-icon/arrow-down.svg
// module id = Nn6z
// module chunks = 317